<template>
  <div class="FaqClientMultiple">
    <FaqClientPage v-if="isReady && !$store.state.user.isSP" ref="faqClient" />
    <FaqClientWindow v-if="isReady && $store.state.user.isSP" ref="faqClient" />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {},
})
export default class FaqClientMultiple extends Vue {
  autoScrollElement = 'init';
  autoScroll() {
    if (this.$refs.faqClient.autoScrollElement) {
      this.$refs.faqClient.autoScroll();
    }
  }
  get isReady() {
    return this.$store.getters['isReady'];
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// products/390/components/FaqClientMultiple.vue